import React, { useState } from "react"
import { Pressable, StyleSheet, Text, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { theme } from "@common/theme/theme"
import FAQComponent from "@common/components/FAQ/FAQComponent"

/**
 * « Questions fréquentes » repliable au bas d'un checkout de funnel.
 *
 * Extraite de l'écran Cours d'été pour être montée à l'identique par les autres
 * funnels : les questions qui retiennent un parent au moment de payer sont les
 * mêmes, et le repli évite d'alourdir la page pour ceux qui n'en ont pas besoin.
 *
 * Rendue nulle sans questions — un funnel qui n'en sert pas n'affiche pas un
 * accordéon vide.
 */
export const FunnelCheckoutFaqSection = ({ faqs }) => {
    const [open, setOpen] = useState(false)
    if (!faqs?.length) return null

    return (
        <View style={styles.faqSection}>
            <Pressable
                style={styles.faqToggle}
                onPress={() => setOpen((o) => !o)}
                accessibilityRole="button"
                accessibilityState={{ expanded: open }}
            >
                <FontAwesome5
                    name="question-circle"
                    solid
                    size={15}
                    color={theme.colors.primary}
                />
                <Text style={styles.faqToggleText}>Questions fréquentes</Text>
                <FontAwesome5
                    name={open ? "chevron-up" : "chevron-down"}
                    size={12}
                    color={theme.colors.grey}
                />
            </Pressable>
            {open ? <FAQComponent faqs={faqs} /> : null}
        </View>
    )
}

const styles = StyleSheet.create({
    faqSection: {
        marginTop: 8,
        borderTopWidth: 1,
        borderTopColor: theme.colors.lightMore,
    },
    faqToggle: {
        flexDirection: "row",
        alignItems: "center",
        gap: 8,
        paddingVertical: 14,
    },
    faqToggleText: {
        flex: 1,
        fontFamily: "Montserrat-Bold",
        fontSize: 14,
        color: theme.colors.primary,
    },
})
